import { useEffect, useState } from "react";
import api from "@/lib/api";
import { toast } from "sonner";
import { Calendar, MapPin, Users } from "lucide-react";
import { useSiteContent } from "@/hooks/useSiteContent";
import { DEFAULTS } from "@/lib/content_defaults";

export default function Events() {
  const [events, setEvents] = useState([]);
  const [loading, setLoading] = useState({});
  const { data: hero } = useSiteContent("page_hero_events", DEFAULTS.page_hero_events);

  useEffect(() => { api.get("/events").then(r => setEvents(r.data)); }, []);

  const register = async (ev) => {
    setLoading({ ...loading, [ev.id]: true });
    try {
      const origin = window.location.origin;
      const { data } = await api.post("/checkout/session", { kind: "event", item_id: ev.id, origin_url: origin });
      window.location.href = data.url;
    } catch (e) {
      toast.error("Could not start checkout.");
      setLoading({ ...loading, [ev.id]: false });
    }
  };

  return (
    <div>
      <section className="section-dark py-20">
        <div className="container-app">
          <div className="label-tag mb-4">{hero.label_tag}</div>
          <h1 className="font-heading font-black uppercase text-5xl md:text-7xl leading-none">{hero.line1}<br/><span className="metallic-gold">{hero.line2}</span><br/>{hero.line3}</h1>
          <p className="mt-6 text-white/70 max-w-2xl text-lg">{hero.subtitle}</p>
        </div>
      </section>
      <section className="section-light py-16">
        <div className="container-app grid md:grid-cols-2 gap-6" data-testid="events-grid">
          {events.map(ev => (
            <div key={ev.id} className="card-light hover-lift overflow-hidden" data-testid={`event-card-${ev.id}`}>
              <div className="aspect-[16/9] overflow-hidden bg-neutral-100">
                {ev.image_url && <img src={ev.image_url} alt={ev.title} className="w-full h-full object-cover"/>}
              </div>
              <div className="p-8">
                <div className="label-tag mb-2" style={{ color: "#000" }}>{ev.event_type}</div>
                <div className="font-heading font-black uppercase text-2xl md:text-3xl">{ev.title}</div>
                <p className="mt-3 text-neutral-700 text-sm leading-relaxed">{ev.description}</p>
                <div className="mt-5 grid grid-cols-2 gap-2 text-xs text-neutral-600">
                  <div className="flex items-center gap-2"><Calendar size={14}/>{new Date(ev.date).toLocaleDateString(undefined, { month: "short", day: "numeric", year: "numeric" })}</div>
                  <div className="flex items-center gap-2"><MapPin size={14}/>{ev.location}</div>
                  {ev.capacity && <div className="flex items-center gap-2"><Users size={14}/>{ev.capacity} spots</div>}
                  {ev.waiver_required && <div className="text-neutral-500">Waiver required</div>}
                </div>
                <div className="mt-6 flex items-center justify-between">
                  <div className="font-heading font-black text-3xl">${ev.price.toFixed(0)}</div>
                  <button onClick={() => register(ev)} disabled={loading[ev.id]} className="btn-gold" data-testid={`event-register-${ev.id}`}>{loading[ev.id] ? "…" : "Register"}</button>
                </div>
              </div>
            </div>
          ))}
        </div>
      </section>
    </div>
  );
}
